import { supportNumberInlineScript } from "../../../util/supportNumbers";

export default function SupportNumberScript() {
  return (
    <script dangerouslySetInnerHTML={{ __html: supportNumberInlineScript }} />
  );
}
